import React, { useContext } from "react";
import HelmetComponent from "../components/common/HelmetComponent";
import "../styles/termsOfService.css";
import { WebsiteContext } from "../context/AppContext";
import { HiLockClosed } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

const privacySections = [
  {
    title: "1. Commitment to User Privacy",
    content:
      "At Fluent Fable, protecting your privacy is our foundational commitment. This policy describes how we collect, store, and safeguard your data when using the Fluent Fable app and website.",
  },
  {
    title: "2. Information We Collect",
    content:
      "We collect information necessary to personalize your learning journey. This includes your account name, email address, practice session history, quiz scores, and vocabulary progress to tailor lesson difficulty to your pace.",
  },
  {
    title: "3. Voice & AI Interaction Data",
    content:
      "Questions submitted to our AI Practice Tutor are analyzed strictly to return pedagogical guidance, grammar corrections, and pronunciation feedback. We do not sell or monetize personal conversational records.",
  },
  {
    title: "4. Cookies & Device Identifiers",
    content:
      "We utilize essential session tokens and analytics identifiers to recognize your preferences, maintain dark/light theme choices, and ensure uninterrupted access to your learning path.",
  },
  {
    title: "5. Data Security & Encryption",
    content:
      "Your personal information and progress metrics are stored behind secure firewalls with industry-standard TLS encryption. We maintain rigorous internal protocols to prevent unauthorized access.",
  },
  {
    title: "6. Your Rights & Data Control",
    content:
      "You have the right to inspect, correct, or request the deletion of your account information at any point. You may contact our data privacy officer at any time to exercise these rights.",
  },
];

const PrivacyPolicy = () => {
  const { color, dark } = useContext(WebsiteContext);
  const navigate = useNavigate();

  return (
    <>
      <HelmetComponent
        title="Privacy Policy | Fluent Fable"
        name="description"
        content="Learn how Fluent Fable safeguards your privacy, personal information, and learning data."
      />

      <div className="legal_page_wrapper">
        <div className="legal_hero_header">
          <span className={`legal_badge ${dark ? "legal_badge_dark" : "legal_badge_light"}`}>
            <HiLockClosed size={16} /> Data Protection & Privacy
          </span>
          <h1 className="legal_main_title" style={{ color: color }}>
            Privacy Policy
          </h1>
          <p className="legal_last_updated" style={{ color: color }}>
            Last Updated: October 2026
          </p>
          <p className="legal_intro_text" style={{ color: color }}>
            Fluent Fable is committed to safeguarding your personal data and ensuring transparent practices regarding how your learning records and information are handled.
          </p>
        </div>

        <div className="legal_sections_stack">
          {privacySections.map((item, index) => (
            <div
              key={index}
              className={`legal_section_card ${dark ? "card_dark" : "card_light"}`}
            >
              <h2 className="legal_section_title">{item.title}</h2>
              <p className="legal_section_body" style={{ color: color }}>
                {item.content}
              </p>
            </div>
          ))}
        </div>

        <div className={`legal_support_box ${dark ? "card_dark" : ""}`}>
          <h3 className="support_box_title" style={{ color: color }}>
            Have Privacy Concerns?
          </h3>
          <p className="support_box_desc" style={{ color: color }}>
            If you have questions about how your data is managed or wish to request data removal, please contact our support desk.
          </p>
          <span
            className="support_email_link"
            onClick={() => navigate("/contact")}
          >
            Contact Privacy Support →
          </span>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
